// extracted by mini-css-extract-plugin
module.exports = {"headline-container":"certification-aggregator-course-directory_headline-container__T1Kxb"};